import { createReducer } from '@src/redux/helpers/createReducer';
import {
  SET_STEP,
  ADD_PAGE_VISITED,
  ADD_PAGE_SUBMITTED,
  REMOVE_SUBMITTED_PAGE,
  CLEAR_STEPS,
} from './constants';

const initialState = {
  step: 1,
  pagesVisited: [],
  pagesSubmitted: [],
};

export const stepsReducer = createReducer(initialState, {
  [SET_STEP]: (state, action) => {
    return {
      step: action.payload,
    };
  },

  [ADD_PAGE_VISITED]: (state, action) => {
    return {
      pagesVisited: action.payload,
    };
  },

  [ADD_PAGE_SUBMITTED]: (state, action) => {
    return {
      pagesSubmitted: action.payload,
    };
  },

  [REMOVE_SUBMITTED_PAGE]: (state, action) => {
    return {
      pagesSubmitted: action.payload,
    };
  },

  [CLEAR_STEPS]: () => {
    return {
      step: initialState.step,
      pagesVisited: initialState.pagesVisited,
      pagesSubmitted: initialState.pagesSubmitted,
    };
  },
});
